export default __webpack_public_path__ + "assets/images/illustration-unconditional-income-9bc3.png";